import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { billingAndShippingStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

billingAndShippingStyles.shipToGridItem = mergeToNew(billingAndShippingStyles.shipToGridItem, {
    printWidth: 4,
});

billingAndShippingStyles.pickUpGridItem = mergeToNew(billingAndShippingStyles.pickUpGridItem, {
    printWidth: 4,
});

billingAndShippingStyles.billToGridItem = mergeToNew(billingAndShippingStyles.billToGridItem, {
    printWidth: 4,
});

billingAndShippingStyles.shipToTitleText = mergeToNew(billingAndShippingStyles.shipToTitleText, {
    css: css`
        margin-bottom: 0;
        padding: 16px;
        background: ${themeBackgrounds.lightGray};
        width: 100%;
    `,
});

billingAndShippingStyles.shipToAddress = mergeToNew(billingAndShippingStyles.shipToAddress, {
    wrapper: {
        css: css`
            padding: 16px;
            background: ${themeBackgrounds.white};
            width: 100%;
        `,
    },
});

billingAndShippingStyles.pickUpTitleText = mergeToNew(billingAndShippingStyles.pickUpTitleText, {
    css: css`
        margin-bottom: 0;
        padding: 16px;
        background: ${themeBackgrounds.lightGray};
        width: 100%;
    `,
});

billingAndShippingStyles.billToText = mergeToNew(billingAndShippingStyles.billToText, {
    css: css`
        width: 100%;
    `,
});

billingAndShippingStyles.pickUpAddress = mergeToNew(billingAndShippingStyles.pickUpAddress, {
    wrapper: {
        css: css`
            padding: 16px;
            background: ${themeBackgrounds.white};
            width: 100%;
        `,
    },
});

billingAndShippingStyles.billToTitleText = mergeToNew(billingAndShippingStyles.billToTitleText, {
    css: css`
        margin-bottom: 0;
        padding: 16px;
        background: ${themeBackgrounds.lightGray};
        width: 100%;
    `,
});
